import React from 'react';
import { cn } from '../../../lib/utils';
import { CaseStudyItemSkeleton } from './CaseStudySkeletons';
import { PaginationSkeleton } from '../PaginationSkeleton';

interface CaseStudyGridSkeletonProps {
  className?: string;
  showPagination?: boolean;
  itemsCount?: number;
}

export function CaseStudyGridSkeleton({
  className = '',
  showPagination = false,
  itemsCount = 9,
}: CaseStudyGridSkeletonProps) {
  const getSkeletonCount = () => {
    const xlCols = 3;
    const minItems = xlCols * 2; // at least 2 rows on xl
    if (itemsCount <= minItems) return minItems;
    const completeRows = Math.ceil(itemsCount / xlCols);
    return Math.max(completeRows * xlCols, minItems);
  };

  const skeletonCount = getSkeletonCount();

  return (
    <div
      className={cn(
        'flex flex-col items-center gap-8 md:gap-20 self-stretch px-6 lg:px-8 xl:px-4xl bg-white md:pb-20 pb-12 pt-8 md:pt-0 skeleton-container',
        className,
      )}
    >
      <div className="flex flex-wrap justify-center gap-8 md:gap-5 xl:gap-x-5 xl:gap-y-16 w-full max-w-screen-xl">
        {Array.from({ length: skeletonCount }).map((_, index) => (
          <CaseStudyItemSkeleton key={index} />
        ))}
      </div>
      {showPagination && (
        <div className="w-full flex justify-center">
          <PaginationSkeleton />
        </div>
      )}
    </div>
  );
}
